import { render, staticRenderFns } from "./IntegrasiMarketplacePage.vue?vue&type=template&id=49dd026b&scoped=true&"
import script from "./IntegrasiMarketplacePage.vue?vue&type=script&lang=js&"
export * from "./IntegrasiMarketplacePage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrasiMarketplacePage.vue?vue&type=style&index=0&id=49dd026b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dd026b",
  null
  
)

export default component.exports